export const PLANS = [
  {
    id: "free",
    name: "Free",
    tagline: "Get your real score in seconds.",
    monthly: 0,
    annual: 0,
    limitLabel: "5 scans / month",
    cta: "Start free",
    features: [
      "Full 8-metric facial analysis",
      "Overall + potential score",
      "AI Coach summary",
      "Public shareable FaceCard",
      "Join the global leaderboard",
    ],
    notIncluded: ["Progress tracking history", "Future-Face projection", "PDF / HD export", "Watermark-free cards"],
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "For people serious about their glow-up.",
    monthly: 12,
    annual: 99,
    monthlyPkg: "pro_monthly",
    annualPkg: "pro_annual",
    limitLabel: "150 scans / month",
    cta: "Go Pro",
    popular: true,
    features: [
      "Everything in Free",
      "Full AI Coach improvement plan",
      "Unlimited progress history & charts",
      "Future-Face projection",
      "Watermark-free FaceCards",
      "PDF & HD image export",
      "Priority analysis queue",
    ],
    notIncluded: [],
  },
  {
    id: "elite",
    name: "Elite",
    tagline: "Unlimited scans + everything unlocked.",
    monthly: 29,
    annual: 249,
    monthlyPkg: "elite_monthly",
    annualPkg: "elite_annual",
    limitLabel: "Unlimited scans",
    cta: "Go Elite",
    features: [
      "Everything in Pro",
      "Unlimited scans",
      "Leaderboard rank boosting",
      "Side-by-side Face Battles",
      "Early access to new metrics",
      "Concierge email support",
    ],
    notIncluded: [],
  },
];
